import "babel-polyfill";
import Vue from 'vue';
import App from './App';
import router from './router';
// 导入vuex
import store from './store/index';
//引入请求工具
import axios from 'axios';
//饿了吗UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import MetaInfo from 'vue-meta-info';

//注册请求工具
import { postRequest,getDateRequest,getRequest,postParamDun } from './utils/api';


Vue.prototype.$posh = "https://ins.xinchacha.com/"; //正式环境
// Vue.prototype.$posh = "http://192.168.0.218:8888/";  //文晓

Vue.prototype.postRequest = postRequest;
Vue.prototype.getDateRequest = getDateRequest;
Vue.prototype.getRequest = getRequest;
Vue.prototype.postParamDun = postParamDun;


Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.use(ElementUI, {
  size: 'small'
});

Vue.use(MetaInfo);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js